import { Language } from "../i18n/translations";

const LANGUAGE_STORAGE_KEY = "taroto-language";
const THEME_STORAGE_KEY = "taroto-theme";

export type Theme = "light" | "dark";

export const localStorageService = {
  getLanguage(): Language | null {
    if (typeof window === "undefined") return null;
    
    try {
      const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
      return stored as Language | null;
    } catch {
      return null;
    }
  },

  setLanguage(language: Language): void {
    if (typeof window === "undefined") return;
    
    try {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    } catch {
      // Silently fail if localStorage is not available
    }
  },

  removeLanguage(): void {
    if (typeof window === "undefined") return;
    
    try {
      localStorage.removeItem(LANGUAGE_STORAGE_KEY);
    } catch {
      // Silently fail if localStorage is not available
    }
  },

  getTheme(): Theme | null {
    if (typeof window === "undefined") return null;
    
    try {
      const stored = localStorage.getItem(THEME_STORAGE_KEY);
      return stored as Theme | null;
    } catch {
      return null;
    }
  },

  setTheme(theme: Theme): void {
    if (typeof window === "undefined") return;
    
    try {
      localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch {
      // Silently fail if localStorage is not available
    }
  },

  removeTheme(): void {
    if (typeof window === "undefined") return;
    
    try {
      localStorage.removeItem(THEME_STORAGE_KEY);
    } catch {
      // Silently fail if localStorage is not available
    }
  },
};